import { TableCell, TableCellProps } from '@material-ui/core';
import React from 'react';
import { MoreVertButton } from '../MoreVertButton';

export type TableCellActionProps = TableCellProps & {
    onButtonClick: React.MouseEventHandler<HTMLElement> | undefined
    disabled?: boolean
}

export function TableCellAction ({ onButtonClick, disabled, ...props }: TableCellActionProps) {
    return (
        <TableCell {...props}>
            <MoreVertButton onClick={onButtonClick} disabled={disabled} />
        </TableCell>
    )
}